import React from 'react';
import { Icon } from '@iconify/react';

type BadgeVariant = 'available' | 'reserved' | 'sold' | 'info' | 'default';

interface BadgeProps {
  variant?: BadgeVariant;
  icon?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const variantStyles: Record<BadgeVariant, React.CSSProperties> = {
  available: {
    background: 'rgba(34, 197, 94, 0.12)',
    color: '#22C55E',
    border: '1px solid rgba(34, 197, 94, 0.20)',
  },
  reserved: {
    background: 'rgba(245, 158, 11, 0.12)',
    color: '#F59E0B',
    border: '1px solid rgba(245, 158, 11, 0.20)',
  },
  sold: {
    background: 'rgba(239, 68, 68, 0.12)',
    color: '#EF4444',
    border: '1px solid rgba(239, 68, 68, 0.20)',
  },
  info: {
    background: 'rgba(59, 130, 246, 0.12)',
    color: '#3B82F6',
    border: '1px solid rgba(59, 130, 246, 0.20)',
  },
  default: {
    background: 'rgba(148, 163, 184, 0.12)',
    color: '#94A3B8',
    border: '1px solid rgba(148, 163, 184, 0.15)',
  },
};

const Badge: React.FC<BadgeProps> = ({ variant = 'default', icon, children, style }) => {
  const badgeStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    borderRadius: 'var(--radius-full)',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'var(--font-body)',
    ...variantStyles[variant],
    ...style,
  };

  return (
    <span style={badgeStyle}>
      {icon && <Icon icon={icon} width={14} />}
      {children}
    </span>
  );
};

export default Badge;
